import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import * as sdk from 'pkg/core/sdk';
import { crash } from 'pkg/errors/errors';

export interface UpdateProductPayload {
	description?: string;
	name?: string;
	productCategoryId?: number;
	isDefault?: boolean;
	archived?: boolean;
}

export const update = async (
	organizationId: number,
	productId: number,
	payload: UpdateProductPayload
): Promise<Response> => {
	const request = await sdk.patch(
		endpoints.Products.Update(organizationId, productId),
		{},
		payload
	);

	if (!request.ok) {
		flashActions.show({
			title: crash().title,
		});
	}

	return request;
};
